@if (orderDetail) {
  <section class="modal-card order-detail">
    <!-- Entête de la modale -->
    <header>
      <div class="order-detail-heading">
        <h2>Détail de l’achat</h2>
        <p>Castorama <strong>{{ orderDetail.orderLocalisation }}</strong></p>
        <p>Achat le <strong>{{ orderDetail.orderDate | date:'dd/MM/yyyy' }}</strong></p>

        @if (context === Context.Customer) {
          <p>Ticket N°<strong>{{ orderDetail.ticketNumber }}</strong></p>
        } @else {
          <span id="barcode"></span>
        }
      </div>

      <p-button id="print-button" class="no-print" icon="pi pi-print" [outlined]="true" (click)="print()"></p-button>
    </header>

    <!-- Corps de la modale -->
    <section class="modal-card-body">

      <div class="text-center no-print" style="margin-bottom: 24px;">
        <ng-casto-btn class="blue" label="Détails et facture" (click)="getReceiptUrl()" [loading]="loadingReceiptUrl"></ng-casto-btn>
      </div>

      @for (product of orderDetail.products; track $index) {
        <table class="product-line">
          <tbody>
          <tr>
            <td>
              <p class="title">EAN</p>
              <p class="value">{{ product.barCode }}</p>
            </td>
            <td>
              <p class="title">QTÉ</p>
              <p class="value">{{ product.quantity }}</p>
            </td>
          </tr>

          <tr>
            <td>
              <p class="title">PRIX UNITAIRE</p>
              <p class="value">{{ product.unitPrice | currency: 'EUR' }}</p>
            </td>
            <td>
              <p class="title">PRIX TTC</p>
              <p class="value"><strong>{{ product.amount | currency: 'EUR' }}</strong></p>
            </td>
          </tr>
          </tbody>
        </table>
      }
    </section>

    <!-- Pied de la modale -->
    <footer>
      <div class="total-price-container">
        <h3>Prix total TTC</h3>
        <div class="total-price">{{ orderDetail.amountTtc | currency: 'EUR' }}</div>
      </div>
      <p-button class="no-print" [outlined]="true" (click)="modalService.close()">Fermer</p-button>
    </footer>
  </section>
} @else {
  <div class="text-center">
    <ng-casto-loader></ng-casto-loader>
  </div>
}
